<template>
	<v-dialog
			:value="isNoteDialog"
			content-class="dialogWrapper"
			persistent
			width="340"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>{{ titleDialog }}</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="groupField_wrap">
					<v-radio-group v-model="type">
						<template v-slot:label>
							<div>Please select type:</div>
						</template>
						<v-radio label="Direct payment" value="1"></v-radio>
						<v-radio label="Facroting" value="2"></v-radio>
					</v-radio-group>

					<field
							:class-error="$v.date && $v.date.$error"
							margin="0 0 10px 0"
							type="text"
							label="Invoice date"
							placeholder="Select date"
							:dateValue="date"
							display-format="YYYY-MM-DD hh:mm"
							@updateDate="onDate($event, 'date')"
							is-required
							is-date
							is-no-title
					></field>
					<field
							:class-error="$v.ref && $v.ref.$error"
							margin="0"
							label="Ref#"
							placeholder="Enter ref number"
							@updateInput="onInput($event, 'ref')"
							:setInputValue="ref"
							is-number
							is-required
					></field>
				</div>
			</div>
			<div class="dialogFooter">
				<div class="buttonGroups">
					<custom-btn
							margin="0"
							text="CANCEL"
							custom-class="cancel"
							@updateEvent="onClose"
					></custom-btn>
					<custom-btn
							margin="0"
							text="generate"
							custom-class="apply"
							@updateEvent="onSave"
					></custom-btn>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "CreateInvoiceDialog",
	mixins: [ validationMixin ],
	props: {
		activeItem: Object,
	},
	validations: {
		ref: { required },
		date: { required },
	},
	data: () => ({
		isNoteDialog: true,
		titleDialog: 'Generate invoice',
		ref: null,
		type: "1",
		date: null,
	}),
	methods: {
		onInput({ value }, key) {
			this[key] = value;
			this.comment = value;
		},
		onDate(value, key) {
			this[key] = value;
		},
		// DELETE
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					ref,
					type,
					date,
				} = this.$data;
				this.$emit('updateGenerateInvoice', { ref, type, date } );
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
	},
	mounted() {
		if (this.activeItem) {
			const { comment } = this.activeItem;
			this.comment = comment;
			this.titleDialog = 'Edit note';
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../dialog";
</style>
